import {
  Form,
  Input,
  Select,
  Radio,
  DatePicker,
  InputNumber,
  Typography,
  Row,
  Col,
  Tooltip,
  Button,
  Collapse,
  Card,
  Checkbox,
  Table,
  ConfigProvider,
  Divider,
} from "antd";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GlobalContext from "../../../context/GlobalContext";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import CustomUpload from "../../../utils/CustomUpload";
import { uploadDocumentAffaire } from "../../../api/geoprod";
import { nanoid } from "nanoid";
import i18next from "i18next";

const { Option } = Select;

const StepForm = ({ fields, id_homologation }) => {
  const formItems = [];
  const { t } = useTranslation();
  const {
    form,
    setGlobalData,
    globalData,
    setCurrentConflictKey,
    setConflictingPlages,
    setShowConflictModal,
  } = useContext(GlobalContext);
  const initialTableState = {};

  const [tableDataMap, setTableDataMap] = useState(initialTableState);
  const modules = form.getFieldValue("modules_formation")
    ? [...form.getFieldValue("modules_formation")]
    : null;

  const setTables = () => {
    const initialData = {};

    fields.sections?.forEach((section) => {
      section.inputs?.forEach((field) => {
        if (field.type !== "table") return;

        const fieldName = field.name;
        const existingData = form.getFieldValue(fieldName) || [];

        if (fieldName === "liste_profils_personnel") {
          const modules =
            form.getFieldValue("modules_formation")?.[0]?.items || [];

          const existingRows = Array.isArray(existingData) ? existingData : [];
          const existingModules = new Set(
            existingRows.map((row) => row.Module)
          );

          const newRows = modules
            .map((module) => {
              const moduleName = Array.isArray(module?.intitulé)
                ? module.intitulé[0]
                : module?.intitulé || "";

              return {
                Module: moduleName,
                compétences: [],
                Diplômes: [],
              };
            })
            .filter((row) => !existingModules.has(row.Module));

          const updatedRows = [...existingRows, ...newRows];

          initialData[fieldName] = updatedRows;
          form.setFieldValue(fieldName, updatedRows);
          setTableDataMap((prev) => ({
            ...prev,
            [fieldName]: updatedRows,
          }));
          return;
        }

        const selectColumn = field.columns?.find(
          (col) =>
            col.type === "select" &&
            Array.isArray(col.options) &&
            col.options.length > 0
        );

        const defaultRowCount = selectColumn?.options.length || 1;
        const defaultRows = Array.from({ length: defaultRowCount }, () => ({}));

        const rows =
          Array.isArray(existingData) && existingData.length > 0
            ? existingData
            : defaultRows;

        initialData[fieldName] = rows;
        form.setFieldValue(fieldName, rows);
        setTableDataMap((prev) => ({
          ...prev,
          [fieldName]: rows,
        }));
      });
    });
  };

  const myCustomRequest = async (name, { file, onSuccess, onError }) => {
    const myIdAffaire = sessionStorage.getItem("id_homologation");
    const myIdTypeDoc = import.meta.env.VITE_APP_ID_TYPE_DOC;
    const formData = new FormData();
    const newFileName = `DOC-${nanoid(12)}.${file.name.split(".").pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    formData.append("id_affaire", myIdAffaire);
    formData.append("id_type_doc", myIdTypeDoc);
    formData.append("file[]", renamedFile);
    formData.append("name_doc", "document_name");
    formData.append("key", "document_key");

    try {
      const res = await uploadDocumentAffaire(formData);
      const fileUrl = res.data.path;
      form.setFieldsValue({
        [name]: fileUrl,
      });

      onSuccess(res);
    } catch (err) {
      console.error(err);
      onError(err);
    }
  };

  useEffect(() => {
    setTables();
  }, [globalData?.modules_formation, fields]);

  const generateEmptyItems = (count, fieldName) => {
    return Array.from({ length: count }, (_, index) => {
      if (fieldName === "semaines_examen" && index === count - 1) {
        // debugger

        return {
          examen_oui: "Oui",
          periode_examen: {
            start: parseInt(globalData.duree_effective - 1),
            end: parseInt(globalData.duree_effective),
          },
        };
      }
      return {};
    });
  };

  fields.sections?.forEach((section, sectionIndex) => {
    if (!section.inputs || !Array.isArray(section.inputs)) return;
    const sectionContent = section.inputs.map((field, i) => {
      if (!field.visible) return null;
      // if (field.type === "table") {
      //   saveModal(field.name, field.columns);
      // }
      const colSpan = {
        xs: field.xs || 24,
        sm: field.sm || 12,
        md: field.md || 8,
      };

      const commonProps = {
        name: field.name,
        label: field.label,

        rules:
          field.type !== "info" && field.type !== "static"
            ? [
                {
                  required: field.required === false ? field.required : true,
                  message: t("Veuillez remplir ce champ."),
                },
                ...(field.type === "email"
                  ? [
                      {
                        pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message: t("Veuillez vérifier ce champ."),
                      },
                    ]
                  : field.type === "phone"
                  ? [
                      {
                        pattern: /^\d{8}$/,
                        message: t("Veuillez vérifier ce champ."),
                      },
                    ]
                  : field.type === "integer"
                  ? [
                      {
                        validator: (_, value) => {
                          if (value === undefined || value === null) {
                            return Promise.resolve();
                          }

                          const hasMin = field.min !== undefined;
                          const hasMax = field.max !== undefined;

                          const isTooSmall = hasMin && value < field.min;
                          const isTooLarge = hasMax && value > field.max;

                          if (isTooSmall || isTooLarge) {
                            let message = "";

                            if (hasMin && hasMax) {
                              if (field.min === field.max) {
                                message = t(`La valeur doit être ${field.max}`);
                              } else {
                                message = t(
                                  `La valeur doit être comprise entre` +
                                    field.min +
                                    t("et") +
                                    field.max
                                );
                              }
                            } else if (hasMin && !hasMax) {
                              message = t(
                                `La valeur doit être supérieure ou égale à ${field.min}`
                              );
                            } else if (!hasMin && hasMax) {
                              message = t(
                                `La valeur doit être inférieure ou égale à ${field.max}`
                              );
                            }

                            return Promise.reject(new Error(message));
                          } else if (
                            field.parserVirgule &&
                            value !== undefined &&
                            !Number.isInteger(value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "Les nombres décimaux ne sont pas autorisés."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]
                  : []),
              ]
            : [],
      };
      const showInfoIcon =
        section.inputs[i + 1] &&
        (section.inputs[i + 1].type === "info" ||
          section.inputs[i + 1].type === "infoLabel") &&
        section.inputs[i + 1].visible;
      let fieldComponent = null;
      const infoTooltip = showInfoIcon ? (
        <Tooltip title={section.inputs[i + 1].label}>
          <span style={{ marginInline: 8, cursor: "pointer" }}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M11.0003 1.83366C5.93758 1.83366 1.83366 5.93758 1.83366 11.0003C1.83366 16.0631 5.93758 20.167 11.0003 20.167C16.0631 20.167 20.167 16.0631 20.167 11.0003C20.167 5.93758 16.0631 1.83366 11.0003 1.83366Z"
                fill="#194FC1"
              />
              <path
                d="M11.0003 9.39616C10.6245 9.39616 10.3128 9.70783 10.3128 10.0837V14.667C10.3128 15.0428 10.6245 15.3545 11.0003 15.3545C11.3762 15.3545 11.6878 15.0428 11.6878 14.667V10.0837C11.6878 9.70783 11.3762 9.39616 11.0003 9.39616ZM10.157 7.68291C10.2028 7.79291 10.267 7.89374 10.3495 7.98541C10.4412 8.06791 10.542 8.13208 10.652 8.17791C10.8752 8.26959 11.1255 8.26959 11.3487 8.17791C11.4587 8.13208 11.5595 8.06791 11.6512 7.98541C11.7337 7.89374 11.7978 7.79291 11.8437 7.68291C11.8895 7.57291 11.917 7.45374 11.917 7.33458C11.917 7.21541 11.8895 7.09624 11.8437 6.98624C11.7978 6.86708 11.7337 6.77541 11.6512 6.68374C11.5595 6.60124 11.4587 6.53708 11.3487 6.49124C11.2387 6.44541 11.1195 6.41791 11.0003 6.41791C10.8812 6.41791 10.762 6.44541 10.652 6.49124C10.542 6.53708 10.4412 6.60124 10.3495 6.68374C10.267 6.77541 10.2028 6.86708 10.157 6.98624C10.1112 7.09624 10.0837 7.21541 10.0837 7.33458C10.0837 7.45374 10.1112 7.57291 10.157 7.68291Z"
                fill="#194FC1"
              />
            </svg>
          </span>
        </Tooltip>
      ) : null;

      switch (field.type) {
        case "text":
          fieldComponent = (
            <Input disabled={field.readOnly || id_homologation || false} />
          );
          break;
        case "divider":
          fieldComponent = (
            <Divider orientation="left" style={{ borderColor: "#6197cb" }}>
              <label style={{ color: "#6197cb", fontWeight: "bold" }}>
                {field.label}
              </label>
            </Divider>
          );
          break;
        case "phone":
          fieldComponent = (
            <Input
              disabled={field.readOnly || id_homologation || false}
              maxLength={8}
              onChange={(e) =>
                form.setFieldValue(
                  field.name,
                  e.target.value.replace(/[^0-9]/g, "")
                )
              }
            />
          );
          break;
        case "range-week":
          fieldComponent = (
            <Input.Group
              compact
              style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <span style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                  {t("Entre")}
                </span>

                <Form.Item
                  name={[field.name, "start"]}
                  noStyle
                  rules={[
                    { required: true, message: t("Semaine de début requise") },
                  ]}
                >
                  <Select
                    disabled={field.readOnly || id_homologation || false}
                    style={{ width: "200px" }}
                    placeholder={t("Début")}
                    onChange={(startValue) => {
                      // debugger
                      const endValue = startValue + 1;
                      form.setFieldValue(field.name, {
                        start: startValue,
                        end: endValue,
                      });

                      const allFormValues = form.getFieldsValue();
                      const allPlages = [];

                      Object.entries(allFormValues).forEach(
                        ([sectionKey, sectionValue]) => {
                          if (Array.isArray(sectionValue)) {
                            sectionValue[0]?.items?.forEach((item, itemIdx) => {
                              Object.entries(item || {}).forEach(
                                ([colKey, val]) => {
                                  if (
                                    val?.start !== undefined &&
                                    val?.end !== undefined
                                  ) {
                                    allPlages.push({
                                      sectionKey,
                                      itemIdx,
                                      colName: colKey,
                                      start: val.start,
                                      end: val.end,
                                    });
                                  }
                                }
                              );
                            });
                          } else if (
                            sectionValue?.start !== undefined &&
                            sectionValue?.end !== undefined
                          ) {
                            allPlages.push({
                              sectionKey,
                              itemIdx: null,
                              colName: sectionKey,
                              start: sectionValue?.start,
                              end: sectionValue?.end,
                            });
                          }
                        }
                      );
                      const key = `${startValue}-${endValue}`;
                      const conflicts = allPlages.filter(
                        (p) => p.start === startValue && p.end === endValue
                      );

                      if (conflicts.length > 1) {
                        setCurrentConflictKey(key);
                        setConflictingPlages((prev) => ({
                          ...prev,
                          [key]: conflicts,
                        }));
                        if (
                          conflicts.length === 2 &&
                          conflicts.some(
                            (e) => e.colName === "periode_stage_obseravation"
                          ) &&
                          conflicts.some(
                            (e) => e.colName === "periode_stage_integration"
                          )
                        ) {
                          return;
                        }
                        setShowConflictModal(true);
                      }
                    }}
                    // defaultValue={
                    //   field.name === "periode_stage_integration"
                    //     ? parseInt(globalData.duree_effective - 1)
                    //     : null
                    // }
                    options={Array.from(
                      { length: globalData?.duree_effective },
                      (_, i) => ({
                        label: `Semaine de formation ${i + 1}`,
                        value: i,
                      })
                    )}
                  />
                </Form.Item>

                <span style={{ fontWeight: 500 }}>{t("et")}</span>

                <Form.Item shouldUpdate noStyle>
                  {() => {
                    const end = form.getFieldValue(field.name)?.end;
                    const display =
                      typeof end === "number"
                        ? `Semaine de formation ${end + 1}`
                        : "";
                    return (
                      <Input
                        disabled
                        style={{
                          width: "200px",
                          textAlign: "center",
                          backgroundColor: "#f5f5f5",
                        }}
                        value={display}
                      />
                    );
                  }}
                </Form.Item>
              </div>
            </Input.Group>
          );
          break;

        case "email":
          fieldComponent = (
            <Input disabled={field.readOnly || id_homologation || false} />
          );
          break;
        case "integer":
          fieldComponent = (
            <InputNumber
              style={{ width: "100%" }}
              disabled={field.readOnly}
              // parser={(value) => {
              //   if (field.parserVirgule) {
              //     return value.replace(/[^\d]/g, "");
              //   } else {
              //     let cleaned = value.replace(/[^0-9.]/g, "");
              //     const parts = cleaned.split(".");
              //     if (parts.length > 2) {
              //       cleaned = parts[0] + "." + parts.slice(1).join("");
              //     }
              //     return cleaned;
              //   }
              // }}
            />
          );
          break;
        case "select":
          fieldComponent = (
            <Select showSearch>
              {field.options?.map((opt) => (
                <Option key={opt} value={opt}>
                  {t(opt)}
                </Option>
              ))}
            </Select>
          );
          break;
        case "radio":
          fieldComponent = (
            <Radio.Group>
              {field.options?.map((opt) => (
                <Radio
                  key={opt}
                  value={opt}
                  disabled={
                    (!field.avisRapporteur &&
                      (field.readOnly ||
                        typeof id_homologation === "string")) ||
                    opt === "Apprentissage"
                  }
                >
                  {t(opt)}
                </Radio>
              ))}
            </Radio.Group>
          );
          break;
        case "file":
          fieldComponent = (
            <CustomUpload
              field={{
                buttonName: t("Téléverser une pièce jointe"),
                title: field?.label,
                name: field?.name,
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              id_affaire={sessionStorage.getItem("id_homologation")}
              id_type_doc={import.meta.env.VITE_APP_ID_TYPE_DOC}
              showIcon={true}
              customRequest={myCustomRequest}
            />
          );
          break;
        case "url":
          fieldComponent = <Input type="url" />;
          break;
        case "duration":
          fieldComponent = <Input />;
          break;
        case "date":
          fieldComponent = (
            <DatePicker
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              disabled={id_homologation}
              disabledDate={field.disabledDate}
            />
          );
          break;
        case "multiselect":
          fieldComponent = (
            <Select mode="multiple">
              {field.options?.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          );
          break;
        case "checkbox":
          fieldComponent = (
            <Checkbox.Group>
              {field.options?.map((opt) => (
                <Checkbox key={opt} value={opt}>
                  {t(opt)}
                </Checkbox>
              ))}
            </Checkbox.Group>
          );
          break;
        case "static":
          fieldComponent = (
            <Typography.Text strong>{field.value}</Typography.Text>
          );
          break;
        case "global":
          fieldComponent = (
            <Typography.Text
              type="secondary"
              style={{
                marginBottom: 16,
                color: "#194FC1",
                display: "flex",
                alignItems: "center",
                fontSize: "1rem",
              }}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M11.0003 1.83366C5.93758 1.83366 1.83366 5.93758 1.83366 11.0003C1.83366 16.0631 5.93758 20.167 11.0003 20.167C16.0631 20.167 20.167 16.0631 20.167 11.0003C20.167 5.93758 16.0631 1.83366 11.0003 1.83366Z"
                  fill="#194FC1"
                />
                <path
                  d="M11.0003 9.39616C10.6245 9.39616 10.3128 9.70783 10.3128 10.0837V14.667C10.3128 15.0428 10.6245 15.3545 11.0003 15.3545C11.3762 15.3545 11.6878 15.0428 11.6878 14.667V10.0837C11.6878 9.70783 11.3762 9.39616 11.0003 9.39616ZM10.157 7.68291C10.2028 7.79291 10.267 7.89374 10.3495 7.98541C10.4412 8.06791 10.542 8.13208 10.652 8.17791C10.8752 8.26959 11.1255 8.26959 11.3487 8.17791C11.4587 8.13208 11.5595 8.06791 11.6512 7.98541C11.7337 7.89374 11.7978 7.79291 11.8437 7.68291C11.8895 7.57291 11.917 7.45374 11.917 7.33458C11.917 7.21541 11.8895 7.09624 11.8437 6.98624C11.7978 6.86708 11.7337 6.77541 11.6512 6.68374C11.5595 6.60124 11.4587 6.53708 11.3487 6.49124C11.2387 6.44541 11.1195 6.41791 11.0003 6.41791C10.8812 6.41791 10.762 6.44541 10.652 6.49124C10.542 6.53708 10.4412 6.60124 10.3495 6.68374C10.267 6.77541 10.2028 6.86708 10.157 6.98624C10.1112 7.09624 10.0837 7.21541 10.0837 7.33458C10.0837 7.45374 10.1112 7.57291 10.157 7.68291Z"
                  fill="#194FC1"
                />
              </svg>

              {field.label}
            </Typography.Text>
          );
          break;

        case "percentage":
          fieldComponent = (
            <InputNumber
              min={0}
              max={100}
              formatter={(value) => `${value}%`}
              parser={(value) => value.replace("%", "")}
              style={{ width: "100%" }}
            />
          );
          break;
        case "accordion":
          fieldComponent = (
            <Collapse
              defaultActiveKey={
                ["0"]
                // form
                //   .getFieldsValue()
                //   [field.name]?.[0]?.items?.map((_, index) =>
                //     index.toString()
                //   ) ||
                // globalData[field.name]?.[0]?.items?.map((_, index) =>
                //   index.toString()
                // )
              }
              expandIconPosition="end"
              style={{ width: "100%" }}
            >
              {field.sections?.map((section, sectionIndex) => (
                <Collapse.Panel
                  header={section.label}
                  key={sectionIndex}
                  style={{ width: "100%", paddingInline: "0.5rem" }}
                >
                  <Form.List
                    name={[field.name, sectionIndex, "items"]}
                    initialValue={generateEmptyItems(
                      field?.defaultCount || 1,
                      field.name
                    )}
                  >
                    {(fields, { add, remove }) => (
                      <Row gutter={16} style={{ width: "100%" }}>
                        {fields.map(({ key, name }, index) => {
                          const content = (
                            <Row gutter={16} style={{ width: "100%" }}>
                              {section.columns.map((col) => {
                                // if (
                                //   col.name === "examen_oui" &&
                                //   index ===
                                //     form.getFieldsValue()?.semaines_examen?.[0]
                                //       ?.items?.length -
                                //       1
                                // ) {
                                //   form.setFieldValue("examen_oui", "Oui");
                                // }
                                // if (
                                //   col.name === "periode_examen" &&
                                //   index ===
                                //     form.getFieldsValue()?.semaines_examen?.[0]
                                //       ?.items?.length -
                                //       1
                                // ) {
                                //   form.setFieldValue(
                                //     [
                                //       field.name,
                                //       sectionIndex,
                                //       "items",
                                //       index,
                                //       col.name,
                                //     ],
                                //     {
                                //       start: parseInt(
                                //         globalData.duree_effective - 1
                                //       ),
                                //       end: parseInt(globalData.duree_effective),
                                //     }
                                //   );
                                // }
                                const colVisible =
                                  col?.name === "periode_examen" ||
                                  col?.name === "nbre_examen_periode" ||
                                  col?.name === "ratrapage_oui"
                                    ? form.getFieldsValue()
                                        ?.semaines_examen?.[0].items[index]
                                        ?.examen_oui === "Oui" ||
                                      index ===
                                        form.getFieldsValue()
                                          ?.semaines_examen?.[0]?.items
                                          ?.length -
                                          1
                                    : col.name === "periode_rattrapage" ||
                                      col.name === "nbre_rattrapage_periode"
                                    ? form.getFieldsValue()
                                        ?.semaines_examen?.[0].items[index]
                                        ?.ratrapage_oui === "Oui" &&
                                      (form.getFieldsValue()
                                        ?.semaines_examen?.[0].items[index]
                                        ?.examen_oui === "Oui" ||
                                        index ===
                                          form.getFieldsValue()
                                            ?.semaines_examen?.[0]?.items
                                            ?.length -
                                            1)
                                    : true;

                                return (
                                  <Col
                                    key={`${key}_${col.name}`}
                                    xs={24}
                                    sm={12}
                                    md={field.cardFieldsMd || 8}
                                    lg={col.md}
                                    style={{ width: "100%" }}
                                  >
                                    {col.type === "range-week" && colVisible ? (
                                      <Form.Item
                                        label=" "
                                        // required
                                        style={{ width: "100%" }}
                                      >
                                        <Input.Group
                                          compact
                                          style={{ width: "100%" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "0.5rem",
                                              width: "100%",
                                            }}
                                          >
                                            <span
                                              style={{
                                                whiteSpace: "nowrap",
                                                fontWeight: 500,
                                              }}
                                            >
                                              {t("Entre")}
                                            </span>

                                            <Form.Item
                                              name={[name, col.name, "start"]}
                                              style={{
                                                flex: 1,
                                                marginBottom: 0,
                                              }}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: t(
                                                    "Semaine de début requise"
                                                  ),
                                                },
                                              ]}
                                            >
                                              <Select
                                                style={{ width: "100%" }}
                                                placeholder={t("Début")}
                                                onChange={(startValue) => {
                                                  const endValue =
                                                    startValue + 1;

                                                  const current =
                                                    form.getFieldValue([
                                                      field.name,
                                                      sectionIndex,
                                                      "items",
                                                      index,
                                                      col.name,
                                                    ]) || {};

                                                  const newPlage = {
                                                    ...current,
                                                    start: startValue,
                                                    end: endValue,
                                                  };

                                                  form.setFieldValue(
                                                    [
                                                      field.name,
                                                      sectionIndex,
                                                      "items",
                                                      index,
                                                      col.name,
                                                    ],
                                                    newPlage
                                                  );

                                                  const allFormValues =
                                                    form.getFieldsValue();
                                                  const allPlages = [];
                                                  Object.entries(
                                                    allFormValues
                                                  ).forEach(
                                                    ([
                                                      sectionKey,
                                                      sectionValue,
                                                    ]) => {
                                                      if (
                                                        Array.isArray(
                                                          sectionValue
                                                        )
                                                      ) {
                                                        sectionValue.forEach(
                                                          (sectionItem) => {
                                                            sectionItem?.items?.forEach(
                                                              (item) => {
                                                                Object.entries(
                                                                  item || {}
                                                                ).forEach(
                                                                  ([
                                                                    colKey,
                                                                    val,
                                                                  ]) => {
                                                                    if (
                                                                      val?.start !==
                                                                        undefined &&
                                                                      val?.end !==
                                                                        undefined
                                                                    ) {
                                                                      allPlages.push(
                                                                        {
                                                                          sectionKey,
                                                                          colName:
                                                                            colKey,
                                                                          start:
                                                                            val.start,
                                                                          end: val.end,
                                                                        }
                                                                      );
                                                                    }
                                                                  }
                                                                );
                                                              }
                                                            );
                                                          }
                                                        );
                                                      } else {
                                                        allPlages.push({
                                                          sectionKey,
                                                          colName: sectionKey,
                                                          start:
                                                            sectionValue?.start,
                                                          end: sectionValue?.end,
                                                        });
                                                      }
                                                    }
                                                  );

                                                  const key = `${newPlage.start}-${newPlage.end}`;
                                                  const conflicts =
                                                    allPlages.filter(
                                                      (p) =>
                                                        p.start ===
                                                          newPlage.start &&
                                                        p.end === newPlage.end
                                                    );

                                                  if (conflicts.length > 1) {
                                                    setCurrentConflictKey(key);
                                                    setConflictingPlages(
                                                      (prev) => ({
                                                        ...prev,
                                                        [key]: conflicts,
                                                      })
                                                    );
                                                    if (
                                                      conflicts.length === 2 &&
                                                      conflicts.some(
                                                        (e) =>
                                                          e.colName ===
                                                          "periode_examen"
                                                      ) &&
                                                      conflicts.some(
                                                        (e) =>
                                                          e.colName ===
                                                          "periode_rattrapage"
                                                      )
                                                    ) {
                                                      return;
                                                    }
                                                    setShowConflictModal(true);
                                                  }
                                                }}
                                                value={
                                                  form.getFieldValue([
                                                    field.name,
                                                    sectionIndex,
                                                    "items",
                                                    index,
                                                    col.name,
                                                  ])?.start
                                                }
                                                disabled={
                                                  ((col?.name ===
                                                    "periode_examen" ||
                                                    col?.name ===
                                                      "periode_rattrapage") &&
                                                    index ===
                                                      form.getFieldsValue()
                                                        ?.semaines_examen?.[0]
                                                        ?.items?.length -
                                                        1) ||
                                                  id_homologation
                                                }
                                                options={Array.from(
                                                  {
                                                    length:
                                                      field.name ===
                                                      "semaines_examen"
                                                        ? globalData[
                                                            `nbre_semaines_periode_${
                                                              index + 1
                                                            }`
                                                          ]
                                                        : globalData?.duree_effective,
                                                  },
                                                  (_, i) => {
                                                    let weekNumber;
                                                    if (
                                                      field.name ===
                                                      "semaines_examen"
                                                    ) {
                                                      const previousWeeksSum =
                                                        Array.from({
                                                          length: index,
                                                        })
                                                          .map(
                                                            (_, idx) =>
                                                              globalData[
                                                                `nbre_semaines_periode_${
                                                                  idx + 1
                                                                }`
                                                              ] || 0
                                                          )
                                                          .reduce(
                                                            (acc, val) =>
                                                              acc + val,
                                                            0
                                                          );
                                                      weekNumber =
                                                        previousWeeksSum + i;
                                                    } else {
                                                      weekNumber = i;
                                                    }

                                                    return {
                                                      label: `Semaine de formation N° ${
                                                        weekNumber + 1
                                                      }`,
                                                      value: weekNumber,
                                                    };
                                                  }
                                                )}
                                              />
                                            </Form.Item>

                                            <span
                                              style={{
                                                fontWeight: 500,
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {t("et")}
                                            </span>

                                            <Form.Item
                                              shouldUpdate
                                              style={{
                                                flex: 1,
                                                marginBottom: 0,
                                              }}
                                            >
                                              {() => {
                                                const end = form.getFieldValue([
                                                  field.name,
                                                  sectionIndex,
                                                  "items",
                                                  index,
                                                  col.name,
                                                ])?.end;

                                                return (
                                                  <Input
                                                    disabled
                                                    style={{
                                                      width: "100%",
                                                      backgroundColor:
                                                        "#f5f5f5",
                                                      textAlign: "center",
                                                    }}
                                                    value={
                                                      typeof end === "number"
                                                        ? `Semaine de formation N° ${
                                                            end + 1
                                                          }`
                                                        : ""
                                                    }
                                                  />
                                                );
                                              }}
                                            </Form.Item>
                                          </div>
                                        </Input.Group>
                                      </Form.Item>
                                    ) : (
                                      colVisible && (
                                        <Form.Item
                                          rules={[
                                            {
                                              required: true,
                                              message: t(
                                                "Veuillez remplir ce champ."
                                              ),
                                            },
                                            ...(col.type === "integer" &&
                                            (col.min !== undefined ||
                                              col.max !== undefined)
                                              ? [
                                                  {
                                                    validator: (_, value) => {
                                                      if (
                                                        value === undefined ||
                                                        value === null
                                                      ) {
                                                        return Promise.resolve();
                                                      }
                                                      const hasMin =
                                                        col.min !== undefined;
                                                      const hasMax =
                                                        col.max !== undefined;

                                                      const isTooSmall =
                                                        hasMin &&
                                                        value < col.min;
                                                      const isTooLarge =
                                                        hasMax &&
                                                        value > col.max;

                                                      if (
                                                        isTooSmall ||
                                                        isTooLarge
                                                      ) {
                                                        let message = "";

                                                        if (hasMin && hasMax) {
                                                          message = t(
                                                            `La valeur doit être comprise entre` +
                                                              col.min +
                                                              t("et") +
                                                              col.max
                                                          );
                                                        } else if (
                                                          hasMin &&
                                                          !hasMax
                                                        ) {
                                                          message = t(
                                                            `La valeur doit être supérieure ou égale à ${col.min}`
                                                          );
                                                        } else if (
                                                          !hasMin &&
                                                          hasMax
                                                        ) {
                                                          message = t(
                                                            `La valeur doit être inférieure ou égale à ${col.max}`
                                                          );
                                                        }

                                                        return Promise.reject(
                                                          new Error(message)
                                                        );
                                                      }

                                                      if (
                                                        col.name ===
                                                        "nbre_heures_proposé"
                                                      ) {
                                                        if (
                                                          modules[0].items[
                                                            index
                                                          ].nbre_heures_prgrm >
                                                          value
                                                        ) {
                                                          return Promise.reject(
                                                            new Error(
                                                              `La valeur doit être supérieure ou égale au nombre d'heures du programme référent`
                                                            )
                                                          );
                                                        }
                                                      }

                                                      return Promise.resolve();
                                                    },
                                                  },
                                                ]
                                              : []),
                                          ]}
                                          name={[name, col.name]}
                                          label={col.label}
                                        >
                                          {col.type === "integer" &&
                                          colVisible ? (
                                            col.name ===
                                            "seuil_réussite_value" ? (
                                              <InputNumber
                                                disabled={id_homologation}
                                                min={0}
                                                max={
                                                  modules?.[0]?.items[index]
                                                    ?.seuil_réussite ===
                                                  "pourcentage"
                                                    ? 100
                                                    : 20
                                                }
                                                addonAfter={
                                                  <Select
                                                    style={{
                                                      backgroundColor:
                                                        index !== 0
                                                          ? "#EBEBE4"
                                                          : "white",
                                                    }}
                                                    value={
                                                      modules?.[0].items[index]
                                                        ?.seuil_réussite
                                                    }
                                                    onChange={(val) => {
                                                      const updatedItems =
                                                        modules[0].items.map(
                                                          (item) => ({
                                                            ...item,
                                                            seuil_réussite: val,
                                                          })
                                                        );

                                                      const updatedModules = [
                                                        ...modules,
                                                      ];
                                                      updatedModules[0].items =
                                                        updatedItems;

                                                      form.setFieldsValue({
                                                        modules: updatedModules,
                                                      });
                                                    }}
                                                    defaultValue={
                                                      index === 0 ||
                                                      !modules[0].items[0]
                                                        .seuil_réussite
                                                        ? "sur 20"
                                                        : modules[0].items[0]
                                                            .seuil_réussite
                                                    }
                                                    options={[
                                                      {
                                                        value: "pourcentage",
                                                        label: "%",
                                                      },
                                                      {
                                                        value: "sur 20",
                                                        label: "/20",
                                                      },
                                                    ]}
                                                    disabled={index !== 0}
                                                  />
                                                }
                                                style={{ width: "100%" }}
                                              />
                                            ) : (
                                              colVisible && (
                                                <InputNumber
                                                  disabled={
                                                    form
                                                      .getFieldValue(
                                                        field.name
                                                      )[0]
                                                      .items[
                                                        index
                                                      ]?.disabled_fields?.includes(
                                                        col.name
                                                      ) ||
                                                    col.readOnly ||
                                                    id_homologation ||
                                                    false
                                                  }
                                                  style={{ width: "100%" }}
                                                  onChange={(e) =>
                                                    form.setFieldsValue({
                                                      ...form.getFieldsValue(),
                                                      [col.name]: e,
                                                    })
                                                  }
                                                />
                                              )
                                            )
                                          ) : col.type === "checkbox" &&
                                            colVisible ? (
                                            <Radio.Group
                                              disabled={
                                                form
                                                  .getFieldValue(field.name)[0]
                                                  .items[
                                                    index
                                                  ]?.disabled_fields?.includes(
                                                    col.name
                                                  ) || id_homologation
                                              }
                                            >
                                              {col.options?.map((opt) => (
                                                <Radio key={opt} value={opt}>
                                                  {t(opt)}
                                                </Radio>
                                              ))}
                                            </Radio.Group>
                                          ) : col.type === "select" &&
                                            colVisible ? (
                                            <Select showSearch>
                                              {col.options?.map((opt) => (
                                                <Option
                                                  key={opt.value}
                                                  value={opt.value}
                                                  disabled={
                                                    opt.readOnly || false
                                                  }
                                                >
                                                  {opt.label}
                                                </Option>
                                              ))}
                                            </Select>
                                          ) : col.type === "selectTag" &&
                                            colVisible ? (
                                            <Select
                                              showSearch
                                              mode="tags"
                                              maxCount={1}
                                              tokenSeparators={[","]}
                                              disabled={
                                                form
                                                  .getFieldValue(field.name)[0]
                                                  .items[
                                                    index
                                                  ]?.disabled_fields?.includes(
                                                    col.name
                                                  ) || id_homologation
                                              }
                                              onSelect={(value) => {
                                                if (
                                                  field.name ===
                                                  "modules_formation"
                                                ) {
                                                  const isFromOptions =
                                                    col.options.some(
                                                      (option) =>
                                                        option.value === value
                                                    );
                                                  const modules = [
                                                    ...form.getFieldValue(
                                                      "modules_formation"
                                                    ),
                                                  ];

                                                  if (modules[0].items[index]) {
                                                    if (isFromOptions) {
                                                      modules[0].items[
                                                        index
                                                      ].type = "Général";
                                                      modules[0].items[
                                                        index
                                                      ].disabled_fields = [
                                                        ...(modules[0].items[
                                                          index
                                                        ].disabled_fields ||
                                                          []),
                                                        "type",
                                                      ];
                                                      modules[0].items[
                                                        index
                                                      ].disabled_fields = [
                                                        ...new Set(
                                                          modules[0].items[
                                                            index
                                                          ].disabled_fields
                                                        ),
                                                      ];
                                                    } else {
                                                      modules[0].items[
                                                        index
                                                      ].disabled_fields = (
                                                        modules?.[0].items[
                                                          index
                                                        ].disabled_fields || []
                                                      ).filter(
                                                        (field) =>
                                                          field !== "type"
                                                      );
                                                    }

                                                    form.setFieldsValue({
                                                      modules_formation:
                                                        modules,
                                                    });
                                                    setGlobalData({
                                                      ...globalData,
                                                      modules_formation:
                                                        modules,
                                                    });
                                                  }
                                                }
                                              }}
                                            >
                                              {col.options?.map((opt) => (
                                                <Option
                                                  key={opt.value}
                                                  value={opt.value}
                                                >
                                                  {opt.label}
                                                </Option>
                                              ))}
                                            </Select>
                                          ) : col.type === "radio" &&
                                            colVisible ? (
                                            <Radio.Group
                                              defaultValue={
                                                col.name === "examen_oui" &&
                                                index ===
                                                  form.getFieldsValue()
                                                    ?.semaines_examen?.[0]
                                                    ?.items?.length -
                                                    1
                                                  ? "Oui"
                                                  : undefined
                                              }
                                              disabled={
                                                (col.name === "examen_oui" &&
                                                  index ===
                                                    form.getFieldsValue()
                                                      ?.semaines_examen?.[0]
                                                      ?.items?.length -
                                                      1) ||
                                                id_homologation
                                              }
                                            >
                                              {col.options?.map((opt) => (
                                                <Radio key={opt} value={opt}>
                                                  {t(opt)}
                                                </Radio>
                                              ))}
                                            </Radio.Group>
                                          ) : col.type === "area" &&
                                            colVisible ? (
                                            <Input.TextArea
                                              rows={1}
                                              disabled={id_homologation}
                                            />
                                          ) : (
                                            colVisible && (
                                              <Input
                                                disabled={
                                                  form
                                                    .getFieldValue(
                                                      field.name
                                                    )[0]
                                                    .items[
                                                      index
                                                    ]?.disabled_fields?.includes(
                                                      col.name
                                                    ) || id_homologation
                                                }
                                                onChange={(e) =>
                                                  form.setFieldsValue({
                                                    ...form.getFieldsValue(),
                                                    [col.name]: e.target.value,
                                                  })
                                                }
                                              />
                                            )
                                          )}
                                        </Form.Item>
                                      )
                                    )}
                                  </Col>
                                );
                              })}
                            </Row>
                          );

                          return (
                            <Col key={key} xs={field.cardMd || 24}>
                              {field.cardType === "accordion" ? (
                                <ConfigProvider
                                  theme={{
                                    components: {
                                      Collapse: {
                                        contentBg: "white",
                                        headerBg: "white",
                                      },
                                    },
                                  }}
                                >
                                  <Collapse
                                    expandIconPosition="end"
                                    style={{ marginBottom: "1rem" }}
                                    // defaultActiveKey={(
                                    //   form.getFieldsValue()?.[field.name]?.[0]
                                    //     ?.items || []
                                    // ).map((_, index) => index.toString())}
                                    defaultActiveKey={["0", "1", "2", "3"]}
                                  >
                                    <Collapse.Panel
                                      header={
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          {field.cardTitle + " N°" || "Élément"}
                                          {index + 1}
                                          {index > 0 &&
                                            field?.canAddItems &&
                                            !form.getFieldValue(field.name)[0]
                                              .items[index]?.stage && (
                                              <Button
                                                disabled={id_homologation}
                                                onClick={() => remove(name)}
                                                style={{ border: "none" }}
                                              >
                                                <DeleteOutlined
                                                  style={{ color: "red" }}
                                                />
                                              </Button>
                                            )}
                                        </div>
                                      }
                                      key={index}
                                      style={{ width: "100%" }}
                                    >
                                      {content}
                                    </Collapse.Panel>
                                  </Collapse>
                                </ConfigProvider>
                              ) : (
                                <Card
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginBottom: "1rem",
                                    // paddingBottom: "1rem",
                                  }}
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {field.cardTitle + t("N°")} {index + 1}
                                      {index > 0 &&
                                        !form.getFieldValue(field.name)[0]
                                          .items[index]?.stage && (
                                          <Button
                                            disabled={id_homologation}
                                            onClick={() => remove(name)}
                                            style={{ border: "none" }}
                                          >
                                            <DeleteOutlined
                                              style={{ color: "red" }}
                                            />
                                          </Button>
                                        )}
                                    </div>
                                  }
                                >
                                  {content}
                                </Card>
                              )}
                            </Col>
                          );
                        })}
                        {field?.canAddItems && (
                          <Button
                            style={{
                              color: "#194FC1",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              // margin:"1rem"
                            }}
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                            disabled={
                              field.length
                                ? field.length <=
                                  form.getFieldValue(field.name)[0]?.items
                                    ?.length
                                : id_homologation
                                ? id_homologation
                                : false
                            }
                          >
                            {field.buttonName}
                          </Button>
                        )}
                      </Row>
                    )}
                  </Form.List>
                </Collapse.Panel>
              ))}
            </Collapse>
          );
          break;
        case "table":
          fieldComponent = (
            <div style={{ width: "100%" }}>
              <Card
                style={{ marginBottom: "20px" }}
                title={<div>{field.title || t("Liste")}</div>}
                extra={
                  <Button
                    type="primary"
                    disabled={
                      field.columns?.some(
                        (col) =>
                          col.type === "select" &&
                          col.options &&
                          col.options.length <=
                            (tableDataMap[field.name]?.length || 0)
                      ) || id_homologation
                    }
                    onClick={() => {
                      const updated = [...(tableDataMap[field.name] || [])];
                      updated.push({});
                      setTableDataMap((prev) => ({
                        ...prev,
                        [field.name]: updated,
                      }));
                      form.setFieldValue(field.name, updated);
                    }}
                    icon={<PlusOutlined />}
                  >
                    {t(field.addButtonLabel || "Ajouter une ligne")}
                  </Button>
                }
              >
                <Table
                  locale={{ emptyText: t("Aucune donnée") }}
                  columns={[
                    ...field.columns.map((col) => ({
                      title: t(col.title),
                      dataIndex: col.dataIndex,
                      key: col.dataIndex,
                      width: col.width,
                      render: (text, record, rowIndex) => {
                        const handleChange = (value) => {
                          const updated = [...(tableDataMap[field.name] || [])];
                          updated[rowIndex] = {
                            ...updated[rowIndex],
                            [col.dataIndex]: value,
                          };

                          if (col.dataIndex === "designation_espaces") {
                            const type = globalData.data_form.space_data.find(
                              (e) => e.space_data_label === value
                            )?.space_data_type;
                            updated[rowIndex] = {
                              ...updated[rowIndex],
                              type_espaces: type,
                            };
                          }
                          setTableDataMap((prev) => ({
                            ...prev,
                            [field.name]: updated,
                          }));
                          form.setFieldValue(field.name, updated);
                        };

                        const rules = col.required
                          ? [
                              {
                                required: true,
                                message: t("Veuillez remplir ce champ"),
                              },

                              {
                                validator: (_, value) => {
                                  const allRows =
                                    form.getFieldsValue()?.[field.name] || [];
                                  // debugger;
                                  if (
                                    col.dataIndex === "designation_equipement" || col.dataIndex === "designation_espaces"
                                  ) {
                                    const isDuplicate = allRows.some(
                                      (row, idx) => {
                                        return (
                                          idx !== rowIndex &&
                                          row?.[col.dataIndex] === value
                                        );
                                      }
                                    );

                                    if (isDuplicate) {
                                      return Promise.reject(
                                        new Error(
                                          "Cette désignation est déjà utilisée dans une autre ligne."
                                        )
                                      );
                                    }
                                  }
                                  const quantityColumn = field.columns.find(
                                    (field) =>
                                      field.title === t("Quantité") &&
                                      field.dataIndex === col.dataIndex
                                  );
                                  if (quantityColumn?.type !== "number") {
                                    return Promise.resolve();
                                  }
                                  const designationKey =
                                    quantityColumn.comparisonDesignation;
                                  const comparisonKey =
                                    quantityColumn.comparisonKey;
                                  const comparisonValueKey =
                                    quantityColumn.comparisonValue;

                                  const currentDesignation =
                                    form.getFieldsValue()?.[field.name]?.[
                                      rowIndex
                                    ]?.[designationKey];

                                  const max = quantityColumn.comparison?.find(
                                    (item) =>
                                      item[comparisonKey] === currentDesignation
                                  )?.[comparisonValueKey];

                                  if (value > max) {
                                    return Promise.reject(
                                      new Error(
                                        `La valeur doit être inférieure ou égale à ${max}, quantité disponible dans l'EPF`
                                      )
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]
                          : [];

                        switch (col.type) {
                          case "select":
                            return (
                              <Form.Item
                                name={[field.name, rowIndex, col.dataIndex]}
                                rules={rules}
                                style={{ margin: 0 }}
                              >
                                <Select
                                  value={text}
                                  style={{ width: "100%" }}
                                  onChange={handleChange}
                                  disabled={
                                    col.readOnly || id_homologation || false
                                  }
                                >
                                  {col.options?.map((opt) => (
                                    <Option
                                      key={opt.value}
                                      value={opt.value}
                                      // disabled={
                                      //   form
                                      //     .getFieldsValue()
                                      //     [field.name]?.map(
                                      //       (item) =>
                                      //         item?.designation_equipement
                                      //     )
                                      //     .filter(
                                      //       (v) => v !== undefined && v !== null
                                      //     )
                                      //     .includes(opt.value) &&
                                      //   opt.value !== text
                                      // }
                                    >
                                      {opt.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            );
                          case "selectTag":
                            return (
                              <Form.Item
                                name={[field.name, rowIndex, col.dataIndex]}
                                rules={rules}
                                style={{ margin: 0 }}
                              >
                                <Select
                                  mode="tags"
                                  tokenSeparators={[","]}
                                  // value={text || []}
                                  onChange={(value) => handleChange(value)}
                                  style={{ width: "100%" }}
                                >
                                  {col.options?.map((opt) => (
                                    <Option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            );
                          case "number":
                            return (
                              <Form.Item
                                name={[field.name, rowIndex, col.dataIndex]}
                                rules={rules}
                                style={{ margin: 0 }}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  min={1}
                                />
                              </Form.Item>
                            );
                          default:
                            return (
                              <Form.Item
                                name={[field.name, rowIndex, col.dataIndex]}
                                rules={rules}
                                style={{ margin: 0 }}
                              >
                                <Input
                                  disabled={col.readOnly}
                                  value={text}
                                  onChange={(e) => handleChange(e.target.value)}
                                />
                              </Form.Item>
                            );
                        }
                      },
                    })),
                    !field.columns?.some(
                      (col) => col.type === "select" && col.options
                    )
                      ? {
                          title: t("Actions"),
                          key: "actions",
                          render: (_, __, index) => {
                            const isDisabled =
                              (tableDataMap[field.name]?.length <= 1 &&
                                !field.columns?.some(
                                  (col) => col.type === "select" && col.options
                                )) ||
                              id_homologation;

                            return (
                              <Button
                                type="text"
                                icon={<DeleteOutlined />}
                                danger
                                disabled={isDisabled}
                                onClick={() => {
                                  const updated = [
                                    ...(tableDataMap[field.name] || []),
                                  ];
                                  updated.splice(index, 1);
                                  setTableDataMap((prev) => ({
                                    ...prev,
                                    [field.name]: updated,
                                  }));
                                  form.setFieldValue(field.name, updated);
                                }}
                              />
                            );
                          },
                          // ) : null,
                        }
                      : null,
                  ].filter(Boolean)}
                  dataSource={tableDataMap[field.name]}
                  rowKey={(_, index) => index}
                  pagination={false}
                  bordered={field.bordered || false}
                />
                {/* <Button
                  type="dashed"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    const updated = [...(tableDataMap[field.name] || [])];
                    updated.push({});
                    setTableDataMap((prev) => ({
                      ...prev,
                      [field.name]: updated,
                    }));
                    form.setFieldValue(field.name, updated);
                  }}
                  style={{ marginTop: "1rem" }}
                >
                  {t(field.addButtonLabel || "Ajouter une ligne")}
                </Button> */}
              </Card>
            </div>
          );
          break;

        case "card":
          fieldComponent = (
            <Card
              style={{ marginBottom: "20px" }}
              title={<div>{field.name}</div>}
            >
              {field.inputs.map((section, sectionIndex) => (
                <div key={sectionIndex} style={{ marginBottom: "20px" }}>
                  <h4>{section.section}</h4>
                  <Row gutter={16}>
                    {section.fields.map((input) => (
                      <Col key={input.name} xs={input.xs}>
                        <Form.Item
                          name={input.name}
                          label={input.label}
                          rules={[
                            {
                              required: input.required ?? true,
                              message: t("Veuillez remplir ce champ"),
                            },
                            ...((input.type === "number" ||
                              input.type === "integer") &&
                            (input.min !== undefined || input.max !== undefined)
                              ? [
                                  {
                                    validator: (_, value) => {
                                      if (
                                        value === undefined ||
                                        value === null
                                      ) {
                                        return Promise.resolve();
                                      }

                                      const hasMin = input.min !== undefined;
                                      const hasMax = input.max !== undefined;

                                      const isTooSmall =
                                        hasMin && value < input.min;
                                      const isTooLarge =
                                        hasMax && value > input.max;

                                      if (isTooSmall || isTooLarge) {
                                        let message = "";

                                        if (hasMin && hasMax) {
                                          if (input.min !== input.max) {
                                            message =
                                              t(
                                                `La valeur doit être comprise entre`
                                              ) +
                                              input.min +
                                              t("et") +
                                              input.max;
                                          } else {
                                            message = t(
                                              `La valeur doit être égale à ${input.max}`
                                            );
                                          }
                                        } else if (hasMin && !hasMax) {
                                          message = t(
                                            `La valeur doit être supérieure ou égale à ${input.min}`
                                          );
                                        } else if (!hasMin && hasMax) {
                                          message = t(
                                            `La valeur doit être inférieure ou égale à ${input.max}`
                                          );
                                        }

                                        return Promise.reject(
                                          new Error(message)
                                        );
                                      }

                                      return Promise.resolve();
                                    },
                                  },
                                ]
                              : []),
                          ]}
                        >
                          {input.type === "select" ? (
                            <Select showSearch>
                              {input.options?.map((opt) => (
                                <Option
                                  key={opt.value}
                                  value={opt.value}
                                  disabled={opt.readOnly || false}
                                >
                                  {opt.label}
                                </Option>
                              ))}
                            </Select>
                          ) : input.type === "textarea" ? (
                            <Input.TextArea rows={3} />
                          ) : input.type === "number" ||
                            input.type === "integer" ? (
                            <Input type="number" />
                          ) : input.type === "radio" ? (
                            <Radio.Group>
                              {input.options?.map((opt) => (
                                <Radio key={opt} value={opt}>
                                  {t(opt)}
                                </Radio>
                              ))}
                            </Radio.Group>
                          ) : (
                            <Input disabled={input.readOnly} />
                          )}
                        </Form.Item>
                      </Col>
                    ))}
                  </Row>
                </div>
              ))}
            </Card>
          );
          break;
        case "area":
          fieldComponent = (
            <Input.TextArea
              rows={field?.rows ? field.rows : 1}
              disabled={
                !field.avisRapporteur &&
                (field.readOnly || id_homologation || false)
              }
            />
          );
          break;
        default:
          fieldComponent = null;
      }

      const fieldBlock =
        field.type !== "global" &&
        field.type !== "accordion" &&
        field.type !== "tableau" &&
        field.type !== "table" &&
        field.type !== "divider" &&
        field.type !== "infoLabel" ? (
          <Col {...colSpan} key={field.name}>
            <Row align="middle" gutter={8}>
              <Col flex="auto">
                <Form.Item
                  {...commonProps}
                  label={
                    <span style={{ whiteSpace: "pre-line", display: "flex" }}>
                      {field.label} {infoTooltip}{" "}
                    </span>
                  }
                  style={{
                    textAlign: i18next.language === "fr" ? "left" : "right",
                  }}
                >
                  {fieldComponent}
                </Form.Item>{" "}
              </Col>
            </Row>
          </Col>
        ) : field.type === "global" ? (
          <Col {...colSpan} key={field.name}>
            {fieldComponent}
          </Col>
        ) : field.type === "tableau" ? (
          <>
            {field.title ? (
              <h3 style={{ color: "#024FA8" }}>{field?.title}</h3>
            ) : null}
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    cellPaddingBlock: 10,
                  },
                },
              }}
            >
              <Table
                className={
                  field?.name === "stages_planning" ||
                  field?.name === "modules_planning" ||
                  field?.name === "Logigramme" ||
                  field?.name === "recap_modules"
                    ? "compact-table"
                    : ""
                }
                size="small"
                style={{ width: "100%", marginBottom: "2rem" }}
                columns={field.columns}
                dataSource={field.moduleItems.map((item, index) => ({
                  key: index,
                  ...item,
                }))}
                rowClassName={(record) =>
                  record.name?.toLowerCase().includes("total") ||
                  record?.isHeader ||
                  record.type === "special"
                    ? "row-total-colored"
                    : record?.type === "year" ||
                      record?.isYearRow ||
                      record?.isTotal
                    ? "row-year-colored"
                    : ""
                }
                pagination={false}
                bordered={field.bordered || false}
              />
            </ConfigProvider>

            {field?.légende && Array.isArray(field?.legendeOptions) && (
              <div
                style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}
              >
                {field.legendeOptions.map((item, idx) => {
                  const color = Object.keys(item)[0];
                  const label = item[color];
                  return (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: color,
                          border: "1px solid #ccc",
                          borderRadius: 2,
                        }}
                      />
                      <span style={{ fontSize: "0.85rem", color: "#555" }}>
                        {label}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ) : (
          field.type !== "infoLabel" && (
            <Col {...colSpan} key={field.name} style={{ marginBottom: "24px" }}>
              {field.type !== "table" && field.type !== "divider" && (
                <div className="ant-form-item">
                  <div className="ant-form-item-label">
                    <label>
                      <span
                        style={{
                          color: "#ff4d4f",
                          display: "inline-block",
                          marginInlineEnd: "4px",
                          fontSize: "14px",
                          lineHeight: 1,
                          fontFamily: "SimSun, sans-serif",
                        }}
                      >
                        *
                      </span>
                      {field.label}
                    </label>
                  </div>
                </div>
              )}

              {fieldComponent}
            </Col>
          )
        );

      // formItems.push(fieldBlock);

      if (showInfoIcon) {
        i++;
      }

      return fieldBlock;
    });
    section.visible &&
      formItems.push(
        <Col span={24} key={`section-${sectionIndex}`}>
          <Card
            title={
              <span
                style={{
                  color: "#6197CB",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginInline: "0.2rem" }}
                >
                  <path
                    opacity="0.4"
                    d="M11.0003 1.83366C5.93758 1.83366 1.83366 5.93758 1.83366 11.0003C1.83366 16.0631 5.93758 20.167 11.0003 20.167C16.0631 20.167 20.167 16.0631 20.167 11.0003C20.167 5.93758 16.0631 1.83366 11.0003 1.83366Z"
                    fill="#194FC1"
                  />
                  <path
                    d="M11.0003 9.39616C10.6245 9.39616 10.3128 9.70783 10.3128 10.0837V14.667C10.3128 15.0428 10.6245 15.3545 11.0003 15.3545C11.3762 15.3545 11.6878 15.0428 11.6878 14.667V10.0837C11.6878 9.70783 11.3762 9.39616 11.0003 9.39616ZM10.157 7.68291C10.2028 7.79291 10.267 7.89374 10.3495 7.98541C10.4412 8.06791 10.542 8.13208 10.652 8.17791C10.8752 8.26959 11.1255 8.26959 11.3487 8.17791C11.4587 8.13208 11.5595 8.06791 11.6512 7.98541C11.7337 7.89374 11.7978 7.79291 11.8437 7.68291C11.8895 7.57291 11.917 7.45374 11.917 7.33458C11.917 7.21541 11.8895 7.09624 11.8437 6.98624C11.7978 6.86708 11.7337 6.77541 11.6512 6.68374C11.5595 6.60124 11.4587 6.53708 11.3487 6.49124C11.2387 6.44541 11.1195 6.41791 11.0003 6.41791C10.8812 6.41791 10.762 6.44541 10.652 6.49124C10.542 6.53708 10.4412 6.60124 10.3495 6.68374C10.267 6.77541 10.2028 6.86708 10.157 6.98624C10.1112 7.09624 10.0837 7.21541 10.0837 7.33458C10.0837 7.45374 10.1112 7.57291 10.157 7.68291Z"
                    fill="#194FC1"
                  />
                </svg>
                {section.name}{" "}
              </span>
            }
            style={{ marginBottom: "2rem", borderRadius: 8 }}
          >
            <Row gutter={16}>{sectionContent}</Row>
          </Card>
        </Col>
      );
  });

  return <Row gutter={16}>{formItems}</Row>;
};

StepForm.propTypes = {
  fields: PropTypes.object,
  id_homologation: PropTypes.string,
};

export default StepForm;
